export enum UserRole {
    ADMIN = 'ADMIN',
    AGENT = 'AGENT',
    ACCOUNTING = 'ACCOUNTING',
    ANALYST = 'ANALYST',
    EMISSIONS = 'EMISSIONS',
    CENTRAL = 'CENTRAL',
}
